import { useState, useEffect } from 'react';
import axios from 'axios';

function useFrame(
  session: string | undefined,
  size: number,
  apikey: string,
  frame: number,
  prerender: number,
  baseUrl = '',
  framerate = 25
) {
  const [lastFrame, setLastFrame] = useState<number>();
  const [lastSize, setLastSize] = useState<number>();
  const [image, setImage] = useState<ImageBitmap>();

  useEffect(() => {
    if(session && (lastFrame !== frame || lastSize !== size|| !image)){
      const headers = { 'x-bj-authorization': 'JWT ' + apikey };

      let unmounted = false;
      let source = axios.CancelToken.source();

      axios
        .get(baseUrl + '/api/' + session + '/' + frame + '?size=' + size + '&frames=' + prerender + '&framerate=' + framerate, {
          responseType: 'blob',
          headers: headers,
          cancelToken: source.token
        })
        .then((res) => {
          if (!unmounted) {
            createImageBitmap(res.data)
            .then((blob) => {
              if (!unmounted) {
                setImage(blob);
              setLastSize(size);
              setLastFrame(frame);
              }
            })
            .catch((err) => {
              console.log(err);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
        return function () {
          unmounted = true;
          source.cancel("Cancelling in cleanup");
      };

    }
  }, [session, baseUrl, size, apikey, frame, prerender, lastFrame, lastSize, image, framerate]);

  if(frame === lastFrame && size === lastSize)
    return image;
  return undefined;
}

export default useFrame;
